import { Fragment } from 'react';
import useResultStatus from '../../application/bloc/useResultStatus';
import { useGetTime } from '../../application/helper/resultExpireTimer';
import { FloatingBox, SideBox } from '../etc/LBox/LBox';
import {
  Skeleton,
  Button,
  Spacer,
  HeadTitle,
  SpacerSection,
  SimpleItem,
  Divider,
} from 'oui';
import Banner from '../dataDisplay/Banner/Banner';

const ResultStatus = () => {
  const {
    isLoading,
    monthlyBannerContent,
    remainTime,
    loanList,
    hasApplyingProductList,
    hasSearchedPreProductList,
    hasNoLoanList,
    sendBeaconClkBtnLoanPrdPrg,
    sendBeaconClkBtnLoanPrdHit,
    sendBeaconClkBtnLoanPrdComplete,
    sendBeaconClkBtnLoanApp,
    navigateDetail,
    terms,
    beacon,
  } = useResultStatus();

  const handleClickLoanItem = (v: any, type: string) => {
    beacon.sendIssueCatch({
      events: { subEventName: 'detail' },
      properties: {
        type: type,
        requestSeq: loanList[type][v]?.requestSeq ?? 0,
        preRequestDtlNo: loanList[type][v]?.preRequestDtlNo,
      },
    });
    navigateDetail(
      loanList[type][v]?.requestSeq,
      loanList[type][v]?.preRequestDtlNo,
    );

    if (type === 'applyingProductList') {
      sendBeaconClkBtnLoanPrdPrg('진행 중인 대출 상품');
    } else if (type === 'practiceProductList') {
      sendBeaconClkBtnLoanPrdComplete('완료된 대출 상품');
    } else if (type === 'searchedPreProductList') {
      sendBeaconClkBtnLoanPrdHit('조회한 대출 상품');
    }
  };

  const handleClickMainButton = (e?: any) => {
    sendBeaconClkBtnLoanApp('오늘의 금리와 한도 조회하기');
    terms.showTerm();
  };

  const toDayRemainTime = useGetTime({
    hour: remainTime?.[0] ?? 0,
    minute: remainTime?.[1] ?? 0,
    second: remainTime?.[2] ?? 0,
  });

  if (isLoading) return <Skeleton type={'c'} />;

  return (
    <>
      <FloatingBox status={false}>
        <Button
          flexible={true}
          configuration={'contained'}
          onClick={(e) => handleClickMainButton(e)}
        >
          오늘의 금리와 한도 조회하기
        </Button>
      </FloatingBox>

      {/* {monthlyBannerContent && (
        <SideBox onClick={monthlyBannerContent.handler}>
          <Spacer size={'md'} />
          <Banner message={monthlyBannerContent.message} />
          {hasNoLoanList && <Spacer size={'md'} />}
        </SideBox>
      )} */}

      {hasSearchedPreProductList && toDayRemainTime !== '00:00:00' && (
        <>
          <HeadTitle
            textTitle={'조회한 대출 상품'}
            subTitle={`${toDayRemainTime} 동안 볼 수 있어요`}
            subTitlePos="top"
            color="purple_blue"
          />
          <SpacerSection
            size={'xs'}
            children={
              <>
                <SideBox>
                  {loanList.searchedPreProductList.map(
                    (item: any, idx: number) => {
                      return (
                        <Fragment key={idx}>
                          {idx > 0 && <Spacer size={'md'} />}
                          <SimpleItem
                            key={
                              idx + item.productNm + 'searchedPreProductList'
                            }
                            state={item.state}
                            avatar={{
                              source: item.logoImgUrl,
                              alt: item.companyNm,
                              size: 'md',
                            }}
                            headerText={item.companyNm}
                            subheaderText={item.productNm}
                            stress={false}
                            onClickSimpleItem={() =>
                              handleClickLoanItem(idx, 'searchedPreProductList')
                            }
                          />
                        </Fragment>
                      );
                    },
                  )}
                </SideBox>
              </>
            }
          />
          {hasApplyingProductList && <Divider type={'content'} />}
        </>
      )}

      {hasApplyingProductList && (
        <>
          <HeadTitle
            textTitle={'신청 중인 대출 상품'}
            subTitle={'최대 7일 동안 상품을 볼 수 있어요'}
          />

          <SpacerSection
            size={'xs'}
            children={
              <>
                <SideBox>
                  {loanList.applyingProductList.map(
                    (item: any, idx: number) => {
                      return (
                        <>
                          {idx > 0 && <Spacer size={'md'} />}
                          <SimpleItem
                            stateChip={item.chip}
                            key={idx + item.productNm + 'applyingProductList'}
                            state={item.state}
                            avatar={{
                              source: item.logoImgUrl,
                              alt: item.companyNm,
                              size: 'md',
                            }}
                            headerText={item.companyNm}
                            subheaderText={item.productNm}
                            stress={false}
                            onClickSimpleItem={() =>
                              handleClickLoanItem(idx, 'applyingProductList')
                            }
                          />
                        </>
                      );
                    },
                  )}
                </SideBox>
              </>
            }
          />
        </>
      )}

      <Spacer size={'lg'} />
      <Spacer size={'lg'} />
      <Spacer size={'lg'} />
    </>
  );
};
export default ResultStatus;
